import { STRATEGIES_ACTIONS } from '../js/Strategies/StrategiesActions';
import { Logger } from '../js/helpers/Logger.js';
import { DRAGGABLE_WINDOWS, MANUAL_MESSAGES_STATUS, MANUAL_MESSAGES_STATUS_CODE, USER_STATE } from '../constants.js';
import BeepChat2 from '../audios/beepChat2.mp3';
import { changeAttachmentsSrc, changeMessageSrc } from '../js/helpers/helperMail';

export function ProcessMessage(message, that) {
	if (message.Sender === 2) {
		if (that.state.logged) {
			that.logOut();
		} else {
			that.stateMachineDown();
		}
		return;
	}

	that.tryMessageToIntegration(message);
	that.sharedData.setIsAssisted(false);
	const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
	switch (message.action) {
		case 'state':
			if (message.currentState === "Login") {
                message.agentData={
                    userName : that.sharedData.user.Login,
                    userId : that.sharedData.user.User_id,
                    userExt : that.sharedData.parameters.Extension
                }
            }
			if (message.currentState === "Assisted") {
				that.sharedData.setIsAssisted(true);
				that.props.changeState(USER_STATE.ASSISTED);
			}
			that.callStateAction(message);
			if(message.action === "InactivePreview")
			{
				that.props.changeState(USER_STATE.INACTIVE);
			}
			break;
		case 'TWITTER_CUSTOMER':
			if (hasUnifiedMessage) {
				that.props.addToast(that.language.getText('GUIUnifiedInboxnewTweet'), { type: 'twitter', from: that.language.getText('GUIUnifiedInboxnewConversation'), position: 'topRight', group: 'inbox' });
				that.props.showUnifiedMessagesWindow(true);
				that.props.newUnifiedInboxConversation(message);
			}
			break;
		case 'MAIL_CUSTOMER':
			if (hasUnifiedMessage) {
				that.props.addToast(that.language.getText('GUIUnifiedInboxnewMail'), {
					type: 'mail',
					from: that.language.getText('GUIUnifiedInboxnewConversation'),
					account: message.ClientAddress,
					position: 'topRight',
					group: 'inbox'
				});

				if(message.EmailMessagesList.length > 0) {
					if(message.EmailMessagesList[0].Message.includes('$domain$')){
						var finalSource = changeMessageSrc(message.EmailMessagesList[0].Message);
						message.EmailMessagesList[0].Message = finalSource;
					}
	
					if(message.EmailMessagesList[0].Attachments.length > 0) {
						var attachments = changeAttachmentsSrc( message.EmailMessagesList[0].Attachments);
						message.EmailMessagesList[0].Attachments = attachments;
					}
				}
				
				that.props.showUnifiedMessagesWindow(true);
				that.props.newUnifiedInboxConversation({ ...message, origin: 'USER' });
			}
			break;
		case 'CHAT_CUSTOMER_ANIMATION':
			if (hasUnifiedMessage) {
				that.props.chatTyping(message);
			}
			break;
		case 'CHAT_CUSTOMER':
			if (hasUnifiedMessage) {
				that.BeepChat2 = new Audio(BeepChat2);
				that.BeepChat2.play();
				that.props.addToast(that.language.getText('GUIUnifiedInboxnewChat'), {
					type: 'chat',
					from: that.language.getText('GUIUnifiedInboxnewConversation'),
					account: message.ClientAddress,
					position: 'topRight',
					group: 'inbox'
				});
				that.props.changeState(USER_STATE.CHATTING);
				that.props.showUnifiedMessagesWindow(true);
				that.props.newUnifiedInboxConversation(message);
			}
			break;
		case 'CHAT_ADMIN_MESSAGE':
			if (hasUnifiedMessage) {
				if (message.ConversationId !== that.props.selectedConversarionID)
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageChat'), { type: 'chat', from: message.From, position: 'topRight', group: 'inbox' });
				that.props.newUnifiedInboxMessage({ ...message, origin: 'ADMIN' });
			}
			break;
		case 'CHAT_CUSTOMER_MESSAGE':
			if (hasUnifiedMessage) {
				that.BeepChat2 = new Audio(BeepChat2);
				that.BeepChat2.play();
				if (message.ConversationId !== that.props.selectedConversarionID)
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageChat'), { type: 'chat', from: message.From, position: 'topRight', group: 'inbox' });
				that.props.newUnifiedInboxMessage({ ...message, origin: 'USER' });
			}
			break;
		case 'CHAT_CUSTOMER_TERMINATION':
			that.BeepChat2 = new Audio(BeepChat2);
			that.BeepChat2.play();
			that.props.endConversationClient(message, true);
			that.props.endConversationChat(message);
			that.props.changeState(USER_STATE.WRAPUP);
			//that.props.changeState(USER_STATE.AGENT_READY);
			break;
		case 'CHAT_TAKEOVER':
			that.props.chatTakeover(message);
			break;
		case 'MAIL_CUSTOMER_MESSAGE':
			if (hasUnifiedMessage) {
				if (message.ConversationId !== that.props.selectedConversarionID)
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageMail'), { type: 'mail', from: message.From, position: 'topRight', group: 'inbox' });
				that.props.newUnifiedInboxMessage({ ...message, origin: 'USER' });
			}
			break;
		case 'TWITTER_CUSTOMER_MESSAGE':
			if (hasUnifiedMessage) {
				if (message.ConversationId !== that.props.selectedConversarionID)
					that.props.addToast(that.language.getText('GUIUnifiedInboxnewMessageTwitter'), { type: 'twitter', from: message.From, position: 'topRight', group: 'inbox' });
				that.props.newUnifiedInboxMessage(message);
			}
			break;
		case 'ALERT':
			that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.setNewPreviewTime(this.props.preview.initPreviewTime)
			if (message.Code === '2021') {
				that.props.agentUnavailableOnTransfer(message);
				if (STRATEGIES_ACTIONS[message.Module]) {
					STRATEGIES_ACTIONS[message.Module](message, that);
				}
			} else {
				Logger.Warn('[App][processMessage] Alert Not implement ', message.action);
			}
			break;
		case 'UNIFIED_INBOX_AUTOMATIC_ANSWERS':
			that.props.chatAnswersTemplates(message);
			break;
		case 'MULTIMEDIA_DISPOSITION':
			that.props.setMultimediaDispositions(message);
			break;
		case 'DISCONNECT':
			Logger.Warn('DISCONNECT State Machine is logout System in reconnect');
			that.messageDisconnect();
			break;
		case 'RECONNECTED':
			Logger.Warn('State machine is up');
			that.setState({ smReady: true });
			break;
		case "NewPreviewCall":
			that.sharedData.setIsAssisted(true);
			that.sharedData.setDataAssistedCall(message);
			that.setState({ datacall: message })
			if (message.Port > 0) {
				that.props.changeState(USER_STATE.RINGING);
				STRATEGIES_ACTIONS[message.action](message, that);
			} else {
				that.props.changeState(USER_STATE.ASSISTED);
			}
			break;
		case "PREVIEWPRO":
			if([100,101,200,201,500].includes(message.DialingMode) ) {
				STRATEGIES_ACTIONS[message.action](message, that)
				return;
			};
			message.dialingMode === 0	? (that.props.changeState(USER_STATE.AGENT_READY)) 
										: (that.props.changeState(USER_STATE.READY_PREVIEW)) ;
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		case "previewData":
			STRATEGIES_ACTIONS[message.action](message, that);   
			that.props.savePreviewRecord(message);   
			break;
		case "UPDATE_DATA_CALL":
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		case "ChangeDialingModeScheduled":
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		case "ALLOW_MARKS_PERMISSION":
			that.sharedData.setAllowMarksPermission(message.PermissionValue);
			break;
		case "MANUAL_MESSAGE":
			const phone = message.code === 0 ? undefined : message.phone;
			that.props.onSetMessageStatus(MANUAL_MESSAGES_STATUS[MANUAL_MESSAGES_STATUS_CODE[message.code]], phone);
			if(message.code === 0){
				that.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_MESSAGE);
			}
			break;
		case "Preview":
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		case "RingingListening":
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		case "NotifyCleanDisplay":
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		default:
			if (STRATEGIES_ACTIONS[message.action]) {
				STRATEGIES_ACTIONS[message.action](message, that);
			} else {
				Logger.Debug('[App][processMessage] Action Not implement ', message.action);
			}
			break;
	}
}



// WEBPACK FOOTER //
// ./src/components/ProcessMessage.js